import React from "react";
class AddCalcullateClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resualt: 0,
      value1: 0,
      value2: 0,
    };
  }
  render() {
    return (
      <div>
        <h1>Add Callculate Class</h1>
        <div>
          value 1 : <input onChange={this.changeV1} />
        </div>
        <div>
          value 2 : <input onChange={this.changeV2} />
        </div>
        <button onClick={this.addFn}>call</button>
        <div>resualt (v1+v2) : {this.state.resualt}</div>
      </div>
    );
  }
  changeV1 = (e) => {
    console.log(e);
    this.setState({ value1: e.target.value });
  };
  changeV2 = (e) => {
    console.log(e);
    this.setState({ value2: e.target.value });
  };
  addFn = () => {
    let resualt = parseInt(this.state.value1) + parseInt(this.state.value2);
    console.log("resualt :", resualt);
    this.setState({ resualt: resualt });
  };
  componentDidMount() {
    this.setState({ resualt: "not calculate" });
  }
  componentWillUnmount() {
    // alert("exit AddCalulateClass");
    //or clear some contrext
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("next v1 ", this.state.value1);
    console.log("prev v1 ", prevState.value1);
    if (this.state.value1 != prevState.value1) {
      //do some thing
    }
  }
}
export default AddCalcullateClass;
